/* eslint-disable */
import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from '@material-ui/core';
import { CurrencyFormatter } from '../Utils/CurrencyFormatter';

const TablaPrior = ({ data }) => {

  console.log("tablapriordata", data)
  const { header, rows } = data;

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            {header.map((item, index) => (
              <TableCell
                key={index}
                style={{ background: 'rgb(231 232 232)', color: '#42526E'}}
              >
                {item}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row, rowIndex) => (
            <TableRow key={rowIndex}>
              {row.map((cell, cellIndex) => (
                <TableCell                
                  key={cellIndex}
                  style={{
                    background:
                        cellIndex === 0 && cell !== "" ? '#EDF4FC' : cellIndex === 1 ? '#689DB8' : 'white',
                    color: cellIndex === 1 && 'white',
                    fontWeight: cellIndex !== 0 ? 'bold' : 'normal',
                  }}
                >
                  <CurrencyFormatter value={cell}/>
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TablaPrior;